export default "__VITE_ASSET__CBen2qdw__"